import { Component, effect, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { settingStore } from '@core/store/index';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';


@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: true,
  styleUrl: './app.css',
  imports: [
    RouterOutlet,
    ToastModule,
    ButtonModule,
    BadgeModule,
    AvatarModule
  ]
})
export class App {
  protected readonly title = signal('condopal');
  settingStore = inject(settingStore);

  constructor(private translate: TranslateService) {
    // Initialize with current language from store
    const initialLang = this.settingStore.data.language();
    this.translate.use(initialLang);

    // Effect to watch for language changes
    effect(() => {
      const currentLang = this.settingStore.data.language();
      if (this.translate.getCurrentLang() !== currentLang) {
        this.translate.use(currentLang);
      }
    });
  }
}
